import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import shareStylesheet from "../ShareSheet.module.scss"
import stylesheet from "./ManualSaveView.module.scss"
import ReactGA from "react-ga"
import { UploadLayout } from "../../.."

interface ManualSaveViewProps {
  imageSrc: string
  aspectRatio: number
  layout: UploadLayout
  onClose: () => void
}

export default function ManualSaveView({ imageSrc, aspectRatio, layout, onClose }: ManualSaveViewProps) {
  const [heldTouch, setHeldTouch] = useState(false)
  const [timer, setTimer] = useState(null)

  const { t } = useTranslation()

  useEffect(() => {
    ReactGA.event({
      category: 'Share Sheet',
      action: 'Manual Save View Appear',
      label: layout
    })
  }, [])

  const newTapAndHoldTimer = () => {
    return setTimeout(() => { 
      ReactGA.event({
        category: 'Share Sheet',
        action: 'Manual Save Complete',
        label: layout
      })
      setHeldTouch(true) 
    }, 1500)
  }

  return (
    <div className={shareStylesheet.shareSheet}>
      <h2 className={shareStylesheet.heading}>{t("shareSheet.manualSave.heading")}</h2>
      <p style={{ maxWidth: "240px" }}>{t("shareSheet.manualSave.instructions")}</p>
      <div className={stylesheet.imagePlaceholder} style={{ width: "240px", height: `${240 / aspectRatio}px` }}>
        <img
          className={stylesheet.saveImage}
          src={imageSrc}
          onTouchStart={() => setTimer(newTapAndHoldTimer())}
          onTouchEnd={() => clearTimeout(timer)}
        />
      </div>
      <div className={shareStylesheet.buttonRow}>
        <button className={heldTouch ? shareStylesheet.blueButton : shareStylesheet.grayButton} onClick={onClose}>
          {heldTouch ? t("shareSheet.buttons.done") : t("shareSheet.buttons.cancel")}
        </button>
      </div>
    </div>
  )
}
